export const ADMIN = "SE-TYR-ProfileImagesHandler.Admin";
export const DOWNLOADER = "SE-TYR-ProfileImagesHandler.Downloader";

export const hasRequiredRoles = (identity, requiredRoles) =>
  Boolean(
    identity?.idTokenClaims?.roles?.find((role) =>
      requiredRoles?.includes(role)
    )
  );

